var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnread({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5645,
    cy: 15.3359,
    r: 15.0967,
    fill: "#F0F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3328 24C16.5398 24 17.5498 23.1399 17.7817 22H12.8828C13.1157 23.1399 14.1257 24 15.3328 24Z",
    fill: "#2683DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0076 16.0029C20.0044 16.0029 20.0025 16.0029 19.9995 16.0029C17.4265 16.0029 15.3325 13.9099 15.3325 11.3359C15.3325 10.6289 15.4956 9.95996 15.7786 9.35791C15.6316 9.34399 15.4834 9.33496 15.3325 9.33496C12.7556 9.33496 10.6655 11.4238 10.6655 14.002V15.8608C10.6655 17.1799 10.0874 18.425 9.07351 19.283C8.73562 19.572 8.58547 20.032 8.70657 20.48C8.84963 21.0029 9.36452 21.3359 9.90652 21.3359H20.7566C21.3245 21.3359 21.8606 20.968 21.9756 20.4119C22.0645 19.9819 21.9116 19.551 21.5774 19.271C20.6074 18.457 20.0476 17.2629 20.0076 16.0029Z",
    fill: "#2684DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 11.334C23.333 13.1748 21.8408 14.667 20 14.667C18.1592 14.667 16.667 13.1748 16.667 11.334C16.667 9.49316 18.1592 8.00098 20 8.00098C21.8408 8.00098 23.333 9.49316 23.333 11.334Z",
    fill: "#2683DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.16d2bdfde3578f3878064d781c05b72d.svg";
export { ForwardRef as ReactComponent };